import { render, staticRenderFns } from "./CTAButton.vue?vue&type=template&id=8e927ba2&scoped=true&"
import script from "./CTAButton.vue?vue&type=script&lang=ts&"
export * from "./CTAButton.vue?vue&type=script&lang=ts&"
import style0 from "./CTAButton.vue?vue&type=style&index=0&id=8e927ba2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e927ba2",
  null
  
)

export default component.exports